import type { Variante } from '../types';

type Props = {
  variante: Variante;
  onChange: (v: Variante) => void;
  disabled?: boolean;
};

export default function VersionToggle({ variante, onChange, disabled }: Props) {
  return (
    <div className="mz-vt" role="tablist" aria-label="Versão da prévia">
      <button
        role="tab"
        type="button"
        aria-selected={variante === 'A'}
        disabled={disabled}
        onClick={() => onChange('A')}
        className={`mz-vt-btn ${variante === 'A' ? 'mz-vt-active' : ''}`}
      >
        <span className="mz-vt-roman">I</span>
        <span className="mz-vt-label">Versão</span>
      </button>

      <div className="mz-vt-divider" aria-hidden />

      <button
        role="tab"
        type="button"
        aria-selected={variante === 'B'}
        disabled={disabled}
        onClick={() => onChange('B')}
        className={`mz-vt-btn ${variante === 'B' ? 'mz-vt-active' : ''}`}
      >
        <span className="mz-vt-roman">II</span>
        <span className="mz-vt-label">Versão</span>
      </button>

      <style>{`
        .mz-vt {
          display: grid;
          grid-template-columns: 1fr auto 1fr;
          align-items: stretch;
          gap: 0;
          margin: 0 16px 22px;
          padding: 5px;
          background: var(--warm-white);
          border: 1.5px solid var(--border-soft);
          border-radius: 18px;
          box-shadow:
            0 1px 0 rgba(255,255,255,0.9) inset,
            0 4px 14px -8px rgba(58,38,24,0.08);
        }

        html[data-theme='dark'] .mz-vt {
          background: rgba(255,255,255,0.04);
        }

        .mz-vt-divider {
          width: 1px;
          background: var(--border-soft);
          margin: 8px 0;
          opacity: 0.6;
        }

        .mz-vt-btn {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          justify-content: center;
          gap: 10px;
          padding: 14px 16px;
          background: transparent;
          border: none;
          border-radius: 14px;
          cursor: pointer;
          color: var(--text-muted);
          font-family: 'DM Sans', sans-serif;
          transition: all 0.22s cubic-bezier(0.4, 0.0, 0.2, 1);
          position: relative;
          min-height: 56px;
        }

        .mz-vt-btn:hover:not(:disabled):not(.mz-vt-active) {
          color: var(--amber-deep);
          background: var(--gold-pale);
        }
        .mz-vt-btn:disabled { opacity: 0.5; cursor: not-allowed; }
        .mz-vt-btn:focus-visible {
          outline: 3px solid var(--gold-pale);
          outline-offset: -2px;
        }

        .mz-vt-active {
          background: linear-gradient(135deg, var(--gold) 0%, var(--gold-hover) 100%);
          color: #fff;
          box-shadow:
            0 4px 14px rgba(255,145,77,0.42),
            0 1px 0 rgba(255,255,255,0.32) inset;
        }

        .mz-vt-roman {
          font-family: 'Playfair Display', 'Source Serif 4', serif;
          font-weight: 800;
          font-style: italic;
          font-size: 22px;
          line-height: 1;
          letter-spacing: -0.02em;
        }

        .mz-vt-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          line-height: 1;
          opacity: 0.92;
        }

        @media (min-width: 720px) {
          .mz-vt { margin: 0 auto 26px; max-width: 480px; }
        }
      `}</style>
    </div>
  );
}
